import supabase from "./supabase";

export async function generateNewJoinCode(classId: string): Promise<{
  join_code: string | null;
  error: string | null;
}> {
  try {
    const { data, error } = await supabase.functions.invoke(
      "generateNewJoinCode",
      {
        body: { classId },
      }
    );

    if (error) {
      console.error("Error generating new join code:", error);
      return { join_code: null, error: error.message };
    }

    return { join_code: data.join_code, error: null };
  } catch (err: any) {
    console.error("Error generating new join code:", err);
    return { join_code: null, error: err.message };
  }
}
